
// 閉じる時にフォーカスを戻さないように
// 配置した親の全域にリスナを追加しないように

import {merge} from 'lodash-es'
import {QContextMenu} from 'quasar'

export default {
  ...QContextMenu,

  render(h) {
    const createElement = (components, options, children) => {
      if(typeof components === 'object' && components.name === 'QPopover') {
        options = merge({}, options, {
          props: {
            noRefocus: true,
          },
        })
      }
      return h(components, options, children)
    }
    return QContextMenu.render.bind(this)(createElement)
  },
  mounted () {},
  beforeDestroy () {},
}
